import React, { useContext } from 'react';
import { View } from 'react-native';
import { Route, Routes as Switch, useLocation } from 'react-router-dom';

import AuthContext from '../contexts/AuthContext';
import Home from '../components/Home';
import Buyers from '../components/Buyers';
import Buyer from '../components/Buyers/show';
import Sellers from '../components/Sellers';
import NewSeller from '../components/Sellers/new';
import Seller from '../components/Sellers/show';
import SellerAssets from '../components/Assets/SellerAssets';
import NewAsset from '../components/Assets/new';
import Asset from '../components/Assets/show';
import EditAsset from '../components/Assets/edit';
import AddableAssets from '../components/Assets/AddableAssets';
import AuctionUsers from '../components/Users/AuctionUsers';
import NewAuctionUser from '../components/Users/AuctionUsers/new';
import AuctionUser from '../components/Users/AuctionUsers/show';
import SellerUsers from '../components/Users/SellerUsers';
import NewSellerUser from '../components/Users/SellerUsers/new';
import SellerUser from '../components/Users/SellerUsers/show';
import Account from '../components/account';
import Sales from '../components/Sales';
import NewSale from '../components/Sales/new';
import Sale from '../components/Sales/show';
import SalePreBids from '../components/Sales/PreBids';
import RecurringSales from '../components/Sales/RecurringSales';
import PaddleServices from '../components/PaddleServices';
import PreBidSchedules from '../components/PreBidSchedules';
import Assets from '../components/Assets';
import AssetsImport from '../components/Assets/Import';
import Reports from '../components/Reports';
import Fees from '../components/Fees';
import TitleLogs from '../components/TitleLogs';
import Expenses from '../components/Expenses';
import PurchaseOrders from '../components/Expenses/PurchaseOrders';
import PurchaseOrder from '../components/Expenses/show';
import AccountsPayable from '../components/Expenses/AccountsPayableIndex';
import Vendors from '../components/Vendors';
import Vendor from '../components/Vendors/show';
import Locations from '../components/Locations';
import Correspondence from '../components/Correspondence';
import Settings from '../components/Settings';
import Colors from '../components/Settings/Colors';
import CommissionsAndSalespeople from '../components/CommissionsAndSalespeople';
import NewTroubleTicket from '../components/TroubleTickets/new';
import InactiveResources from '../components/InactiveResources';
import BuyerSales from '../components/Sales/BuyerSales';
import Conversations from '../components/Conversations';

import useSubscriptions from 'app/src/hooks/useSubscriptions';
import Chat from '../elements/Chat';

import Auctioneer from '../components/Bidding/Auctioneer';
import Clerk from '../components/BiddingNew/Clerk';
import Hud from '../components/BiddingNew/Hud';
import Streams from '../components/BiddingNew/Streams';
import BiddingEvents from '../components/BiddingNew/Events';
import BiddingBuyers from '../components/BiddingNew/Buyers';

import AccountingRoutes from 'app/src/components/Accounting/Routes';
import AccountingDashboard from '../components/Accounting/Dashboard';

import Blogs from '../components/Blogs';

import Dashboard from 'app/src/components/Dashboard';
import Blog from '../components/Blogs/show';

const Routes = () => {
  useSubscriptions();
  const { currentUser, availableForChat } = useContext(AuthContext);
  const location = useLocation();

  return (
    <>
      <Switch>
        <Route path="/" element={<Home />} exact />
        <Route path="/locations" element={<Locations />} exact />
        <Route path="/buyers" element={<Buyers />} exact />
        <Route path="/buyers/:buyerId" element={<Buyer />} exact />
        <Route path="/sellers" element={<Sellers />} exact />
        <Route
          path="/sellers/declined"
          element={<Sellers scope="declined" />}
          exact
        />
        <Route
          path="/sellers/pending"
          element={<Sellers scope="pending" />}
          exact
        />
        <Route path="/sellers/new" element={<NewSeller />} exact />
        <Route path="/sellers/:sellerId" element={<Seller />} exact />
        <Route path="/sellers/:sellerId/users" element={<SellerUsers />} exact />
        <Route path="/sellers/:sellerId/users/new" element={<NewSellerUser />} exact />
        <Route path="/sellers/:sellerId/users/:userId" element={<SellerUser />} exact />
        <Route path="/sellers/:sellerId/assets" element={<SellerAssets />} exact />
        <Route path="/sellers/:sellerId/assets/new/:sellerName" element={<NewAsset />} exact />
        <Route path="/sellers/:sellerId/assets/:assetId" element={<Asset />} exact />
        <Route path="/sellers/:sellerId/assets/:assetId/edit" element={<EditAsset />} exact />
        <Route path="/sellers/:sellerId/assets/:assetId/expenses" element={<Expenses />} exact />
        <Route path="/expenses" element={<Expenses />} exact />
        <Route path="/purchase-orders" element={<PurchaseOrders />} exact />
        <Route path="/purchase-orders/:expenseId" element={<PurchaseOrder />} exact />
        <Route path="/accounts-payable" element={<AccountsPayable />} exact />
        <Route path="/fees" element={<Fees />} exact />
        <Route path="/sales/sales-people" element={<Home />} exact />
        <Route path="/sales" element={<Sales />} exact />
        <Route path="/sales/new" element={<NewSale />} exact />
        <Route path="/sales/:id" element={<Sale />} exact />
        <Route path="/sales/:id/asset/:saleAssetId" element={<Sale />} exact />
        <Route path="/sales/recurring-sales" element={<RecurringSales />} exact />
        <Route path="/sales/:id/add-assets" element={<AddableAssets />} exact />
        <Route path="/sales/:id/:tableType" element={<Sale />} exact />
        <Route path="/sales/:id/buyer-sales" element={<BuyerSales />} exact />
        <Route path="/sales/:saleId/pre-bids" element={<SalePreBids />} exact />
        <Route path="/paddle-services" element={<PaddleServices />} exact />
        <Route path="/pre-bid-schedules" element={<PreBidSchedules />} exact />
        <Route path="/title-logs" element={<TitleLogs />} exact />
        <Route path="/assets" element={<Assets />} exact />
        <Route path="/assetsImport" element={<AssetsImport />} exact />
        <Route path="/account" element={<Account />} exact />
        {/* <Route path="/commissions" element={<Commissions />} exact /> */}
        <Route path="/releases" element={<Correspondence />} exact />
        {currentUser?.accounting && (
          <>
            <Route path="/users" element={<AuctionUsers />} exact />
            <Route path="/users/new" element={<NewAuctionUser />} exact />
            <Route path="/users/:id" element={<AuctionUser />} exact />
          </>
        )}
        <Route path="/settings" element={<Settings />} exact />
        <Route path="/settings/colors" element={<Colors />} exact />
        <Route path="/reports" element={<Reports />} exact />
        <Route path="/vendors" element={<Vendors />} exact />
        <Route path="/vendors/:id" element={<Vendor />} exact />
        {/* <Route path="/salespeople" element={<Salespeople />} exact /> */}
        <Route path="/commissions-and-salespeople"
          element={<CommissionsAndSalespeople />} exact
        />
        <Route path="/bidding/auctioneer/:id" element={<Auctioneer />} exact />
        <Route path="/bidding/clerk/:id" element={<Clerk />} exact />
        <Route path="/bidding/hud/:id" element={<Hud />} exact />
        <Route path="/bidding/events/:id" element={<BiddingEvents />} exact />
        <Route path="/bidding/streams/:id" element={<Streams />} exact />
        <Route path="/bidding/buyers/:id" element={<BiddingBuyers />} exact />
        <Route path="/trouble-ticket/new" element={<NewTroubleTicket />} exact />
        <Route path="/inactive-resources" element={<InactiveResources />} exact />
        <Route path="/conversations" element={<Conversations />} exact />

        <Route path="/accounting" element={<AccountingDashboard />} />
        <Route path="/accounting/*" element={<AccountingRoutes />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="blog" element={<Blogs />} />
        <Route path="blog/:id" element={<Blog />} />
      </Switch>
      {(availableForChat || location.pathname.includes("/bidding/")) &&
        <View style={{position: 'fixed', right: 0, bottom: 0}}>
          <Chat />
        </View>
      }
    </>
  );
}

export default Routes;
